import { useEffect, useState } from "react";
import ButtonElement from "../../../Common/ButtonElement";
import TableComponent from "../../components/TableComponent";
import SearchBox from "../../components/SearchComponent";
import { DELETE_POP_UP, formatDate, isValidObject } from "../../../utils";
import { appApis, headerColumn } from "../../../constants";
import GpsMapping from "./GpsMapping";
import { getMappingData } from "../../../actions/inventory";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useApiRequest } from "../../../hooks/useApiRequest";

const DeviceMapping = () => {
    const [state, setState] = useState({
        mappings: [],
        showMapping: false,
        loading: false,
        search: "",
        activeTab: "Current"
    });

    const { mappings, loading, showMapping, activeTab } = state;
    const { request: makiApiRequest, loading: deleteRequest } = useApiRequest();

    const getMappings = (isCurrent) => {
        setState(prev => ({ ...prev, loading: true, activeTab: isCurrent ? "Current" : "Past" }));
        getMappingData(`showCurrentMapping=${isCurrent}`).then(response => {
            const { data } = response.data;
            if (isValidObject(data)) {
                setState(prev => ({ ...prev, mappings: data?.mappingData ?? [] }));
            }
        }).catch(ex => { }).finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    const changeTab = (tab) =>{
        if(tab != activeTab) getMappings(tab == "Current");
    }

    const removeRequest = (id) => {
        if (id) {
            DELETE_POP_UP(() => makiApiRequest({
                url: `${appApis.revertMapping}?mappingId=${id}`,
                method: "PUT",
                showToast: false,
                onSuccess: () => getMappings(true)
            }))
        }
    }

    useEffect(() => {
        getMappings(true);
    }, [])

    return <div className="installer-container">
        {/* <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} /> */}
        <TableComponent col={4} breakPoint="lg" title={"Device SIM Mapping"} headers={activeTab == "Current" ? [...headerColumn.mapping, "Action"] : headerColumn.mapping} data={mappings} tableLoading={loading}
            TabComponent={<div className="tabs p-1 rounded d-md-flex justify-content-between text-center">
                {["Current", "Past"].map((tab, index) => <div className={`d-flex justify-content-center align-items-center rounded py-2 flex-fill ${activeTab == tab ? "active" : ""} mx-1`} key={index} onClick={() => changeTab(tab)}><div className="ms-2">{tab}</div>
                </div>)}
            </div>}
        render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.y_current_state ?? "-"}</td>
            <td>{tdData?.y_gps_imei ?? "-"}</td>
            <td>{tdData?.y_iccid ?? "-"}</td>
            <td>{tdData?.y_sim_number ?? "-"}</td>
            <td>{formatDate(tdData?.y_mapped_on ?? "")}</td>
            {activeTab == "Current" ? <td>
                <ButtonElement text={<RiDeleteBin5Line size={20} />} cssClass="more-radius px-4" onClick={() => removeRequest(tdData?.y_mapping_id ?? 0)} variant="btn-delete-icon" loading={deleteRequest} />
            </td> : null}
        </tr>} FilterComponent={<div className="installer-filters d-flex justify-content-end">
            <ButtonElement text={"GPS Mapping"} cssClass="more-radius me-1 mb-1" onClick={() => setState(prev => ({ ...prev, showMapping: true }))} variant="btn-blue-no-hover" loading={false} />
        </div>} />
        {showMapping ? <GpsMapping show={showMapping} successAction={() => getMappings(true)} hideModal={() => setState(prev => ({ ...prev, showMapping: false }))}  /> : null}
    </div>
}

export default DeviceMapping;